import { useState } from "react";

export default function LearningReflection({ prompts = [], value, onChange }) {
    const [internal, setInternal] = useState("");
    const v = value ?? internal;
    const handle = (e) => {
        const next = e.target.value;
        if (onChange) onChange(next);
        else setInternal(next);
    };

    return (
        <section className="tile rounded-sm p-6 lg:p-8" data-testid="learning-reflection">
            <div className="overline mb-3">Learning reflection</div>
            <h3 className="text-xl lg:text-2xl font-bold tracking-tight mb-5">
                What did this rehearsal teach the room?
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 text-sm text-slate-700 mb-6 list-disc pl-5">
                {prompts.map((p) => (
                    <li key={p}>{p}</li>
                ))}
            </ul>
            <label className="block">
                <span className="overline">Facilitator notes (private to this run)</span>
                <textarea
                    rows={4}
                    value={v}
                    onChange={handle}
                    placeholder="Capture what surprised the room, where authority was unclear, where evidence was missing..."
                    className="mt-2 w-full border border-slate-200 rounded-sm p-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400"
                    data-testid="learning-reflection-notes"
                />
            </label>
        </section>
    );
}
